module.exports = __webpack_public_path__ + "static/media/5.4e5e2b1b.jpeg";